import { HandlerEvent } from 'post-robot';
import { reset as resetState } from 'communicator/store';
import { getAccessToken, getIsVisaSRCi } from 'communicator/store/selectors';
import unbind from 'communicator/utils/unbind';

type ResetData = { idToken?: string; unbindAppInstance?: boolean } | undefined;

export default function reset(event: HandlerEvent<ResetData>) {
  // In case of Visa SRCi, VSB SDK will directly call vco.unbindAppInstance()
  // following checkout.
  if (!getIsVisaSRCi() && event.data?.unbindAppInstance) {
    unbind({
      accessToken: getAccessToken()?.token,
      idTokens: event.data.idToken ? [event.data.idToken] : undefined
    });
  }

  resetState();
}
